import React, { useEffect } from "react";
import { FmCarbonTableHeaderRow } from "./FmCarbonTableHeaderRow";
import { FmCarbonTableContentRow } from "./FmCarbonTableContentRow";
import { AgriSolutionState } from "../../Redux";
import { ShowWhen } from "../ShowWhen";
import { useTheme } from "../../Hooks";
import { FmCarbonIndexDialog } from "./FmCarbonIndexDialog";
import { Stack } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../Redux/Hooks/Hooks";
import CFPTabelSelectors from "../../Redux/States/CFPTable/selectors";
import { useTranslation } from "react-i18next";
import { REDUCED_CO2_MEASURE_UNIT, REDUCED_CO2_PLOT_MEASURE_UNIT } from "../../Constants/Calculations";
import { CFPTableActions } from "../../Redux/States/CFPTable";
import { FmCarbonBanner } from "../FmCarbonBanner/FmCarbonBanner";

export const FmCarbonFootprintTable = () => {
  const isTableOpen = useAppSelector((state) => state.agriSolution.releaseGraphState.isCarbonTableOpen);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const carbonFootprintData = useAppSelector((state) => state.cfpTable.tableData);
  const reducedCo2 = useAppSelector(CFPTabelSelectors.reducedCo2);
  const expectedYield = useAppSelector((state) => state.agriSolution.cropsState.expectedYield);
  const metricMethod = useAppSelector((state) => Number.parseInt(state.general.activeMetricMethod || "-1"));
  const plotSize = useAppSelector((state) => state.agriSolution.plotSize);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      CFPTableActions.setEntireLabels({
        carbonFootprint: {
          label: t("cfpTable.tableRows.carbonFootprint.label"),
          measureUnit: t("cfpTable.tableRows.carbonFootprint.measureUnit"),
        },
        nitrogenLeaching: {
          label: t("cfpTable.tableRows.nLeaching.label"),
          measureUnit: t("cfpTable.tableRows.nLeaching.measureUnit"),
        },
        nitrogenRunoff: {
          label: t("cfpTable.tableRows.nRunOff.label"),
          measureUnit: t("cfpTable.tableRows.nRunOff.measureUnit"),
        },
        nitrogenTerrestrialEutrophication: {
          label: t("cfpTable.tableRows.terrestrialEutrophication.label"),
          measureUnit: t("cfpTable.tableRows.terrestrialEutrophication.measureUnit"),
        },
        nitrogenVolatilization: {
          label: t("cfpTable.tableRows.nVolatilization.label"),
          measureUnit: t("cfpTable.tableRows.nVolatilization.measureUnit"),
        },
      }),
    );
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <ShowWhen when={reducedCo2 > 0 && expectedYield}>
        <FmCarbonBanner />
      </ShowWhen>

      {/* Table Header */}
      <FmCarbonTableHeaderRow />

      {/* Full Table Content  */}
      <ShowWhen when={isTableOpen}>
        <div>
          {carbonFootprintData.map((e, idx) => (
            <FmCarbonTableContentRow key={idx + "_key"} isLastChild={idx == carbonFootprintData.length - 1} {...e} />
          ))}
        </div>

        <img
          src={theme.images.carbonTableLeaf}
          alt=""
          style={{
            position: "absolute",
            bottom: 78,
            left: "32%",
            opacity: 0.3,
            userSelect: "none",
            pointerEvents: "none",
          }}
          draggable={false}
        />
      </ShowWhen>

      {/* Partial Table Content  */}
      <ShowWhen when={!isTableOpen}>
        <FmCarbonTableContentRow {...carbonFootprintData[0]} />
      </ShowWhen>

      <Stack width="100%" direction="row" justifyContent="flex-end">
        <img src={theme.images.simaproLogo} alt="powered by sima pro" height="40" />
      </Stack>

      {/* Table View Mode */}
      <div
        onClick={() => dispatch(AgriSolutionState.Actions.toggleCarbonTable(!isTableOpen))}
        style={{
          fontSize: 16,
          fontWeight: 400,
          textDecoration: "solid underline",
          cursor: "pointer",
          margin: "14px 0",
        }}
      >
        {isTableOpen ? "See Less" : "See More"}
      </div>

      {/* Index Rate Dialog */}
      <FmCarbonIndexDialog />
    </div>
  );
};
